var map = {
	"./": [
		312,
		9
	],
	"./UserSettings": [
		1155,
		9,
		6,
		14,
		151
	],
	"./UserSettings.dictionary": [
		346,
		3
	],
	"./UserSettings.dictionary.json": [
		346,
		3
	],
	"./UserSettings.tsx": [
		1155,
		9,
		6,
		14,
		151
	],
	"./UserSettingsDeferred": [
		379,
		9
	],
	"./UserSettingsDeferred.tsx": [
		379,
		9
	],
	"./components/ChangeButton": [
		859,
		9,
		40
	],
	"./components/ChangeButton/": [
		859,
		9,
		40
	],
	"./components/ChangeButton/ChangeButton.module.scss": [
		937,
		9,
		293
	],
	"./components/ChangeButton/index": [
		859,
		9,
		40
	],
	"./components/ChangeButton/index.tsx": [
		859,
		9,
		40
	],
	"./components/SettingToggler": [
		916,
		9,
		61
	],
	"./components/SettingToggler/": [
		916,
		9,
		61
	],
	"./components/SettingToggler/SettingToggler.module.scss": [
		1051,
		9,
		315
	],
	"./components/SettingToggler/index": [
		916,
		9,
		61
	],
	"./components/SettingToggler/index.tsx": [
		916,
		9,
		61
	],
	"./components/SettingsLoader": [
		935,
		9,
		62
	],
	"./components/SettingsLoader/": [
		935,
		9,
		62
	],
	"./components/SettingsLoader/index": [
		935,
		9,
		62
	],
	"./components/SettingsLoader/index.tsx": [
		935,
		9,
		62
	],
	"./components/SettingsSection": [
		833,
		9,
		63
	],
	"./components/SettingsSection/": [
		833,
		9,
		63
	],
	"./components/SettingsSection/SettingsSection.module.scss": [
		850,
		9,
		316
	],
	"./components/SettingsSection/index": [
		833,
		9,
		63
	],
	"./components/SettingsSection/index.tsx": [
		833,
		9,
		63
	],
	"./components/ThemeSetting": [
		986,
		9,
		74
	],
	"./components/ThemeSetting/": [
		986,
		9,
		74
	],
	"./components/ThemeSetting/ThemeSetting": [
		987,
		9,
		221
	],
	"./components/ThemeSetting/ThemeSetting.dictionary": [
		934,
		3,
		222
	],
	"./components/ThemeSetting/ThemeSetting.dictionary.json": [
		934,
		3,
		222
	],
	"./components/ThemeSetting/ThemeSetting.explanation": [
		1156,
		9,
		223
	],
	"./components/ThemeSetting/ThemeSetting.explanation.ts": [
		1156,
		9,
		223
	],
	"./components/ThemeSetting/ThemeSetting.module.scss": [
		1047,
		9,
		324
	],
	"./components/ThemeSetting/ThemeSetting.tsx": [
		987,
		9,
		221
	],
	"./components/ThemeSetting/components/ThemeCardWrapper": [
		903,
		9,
		75
	],
	"./components/ThemeSetting/components/ThemeCardWrapper/": [
		903,
		9,
		75
	],
	"./components/ThemeSetting/components/ThemeCardWrapper/ThemeCardWrapper": [
		878,
		9,
		224
	],
	"./components/ThemeSetting/components/ThemeCardWrapper/ThemeCardWrapper.module.scss": [
		933,
		9,
		325
	],
	"./components/ThemeSetting/components/ThemeCardWrapper/ThemeCardWrapper.tsx": [
		878,
		9,
		224
	],
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard": [
		858,
		9,
		76
	],
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard/": [
		858,
		9,
		76
	],
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard/ThemeCard": [
		843,
		9,
		225
	],
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard/ThemeCard.module.scss": [
		879,
		9,
		326
	],
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard/ThemeCard.tsx": [
		843,
		9,
		225
	],
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard/components/ThemeCardItem": [
		844,
		9,
		77
	],
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard/components/ThemeCardItem/": [
		844,
		9,
		77
	],
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard/components/ThemeCardItem/ThemeCardItem": [
		835,
		9,
		226
	],
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard/components/ThemeCardItem/ThemeCardItem.module.scss": [
		851,
		9,
		327
	],
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard/components/ThemeCardItem/ThemeCardItem.tsx": [
		835,
		9,
		226
	],
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard/components/ThemeCardItem/index": [
		844,
		9,
		77
	],
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard/components/ThemeCardItem/index.ts": [
		844,
		9,
		77
	],
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard/index": [
		858,
		9,
		76
	],
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard/index.ts": [
		858,
		9,
		76
	],
	"./components/ThemeSetting/components/ThemeCardWrapper/index": [
		903,
		9,
		75
	],
	"./components/ThemeSetting/components/ThemeCardWrapper/index.ts": [
		903,
		9,
		75
	],
	"./components/ThemeSetting/index": [
		986,
		9,
		74
	],
	"./components/ThemeSetting/index.ts": [
		986,
		9,
		74
	],
	"./components/UserMainSettings": [
		988,
		9,
		6,
		79
	],
	"./components/UserMainSettings/": [
		988,
		9,
		6,
		79
	],
	"./components/UserMainSettings/UserContacts": [
		936,
		9,
		6,
		80
	],
	"./components/UserMainSettings/UserContacts/": [
		936,
		9,
		6,
		80
	],
	"./components/UserMainSettings/UserContacts/UserContacts.dictionary": [
		992,
		3,
		228
	],
	"./components/UserMainSettings/UserContacts/UserContacts.dictionary.json": [
		992,
		3,
		228
	],
	"./components/UserMainSettings/UserContacts/index": [
		936,
		9,
		6,
		80
	],
	"./components/UserMainSettings/UserContacts/index.tsx": [
		936,
		9,
		6,
		80
	],
	"./components/UserMainSettings/UserEmail": [
		954,
		9,
		6,
		81
	],
	"./components/UserMainSettings/UserEmail/": [
		954,
		9,
		6,
		81
	],
	"./components/UserMainSettings/UserEmail/UserEmail.dictionary": [
		955,
		3,
		229
	],
	"./components/UserMainSettings/UserEmail/UserEmail.dictionary.json": [
		955,
		3,
		229
	],
	"./components/UserMainSettings/UserEmail/UserEmail.module.scss": [
		860,
		9,
		328
	],
	"./components/UserMainSettings/UserEmail/components/EmailModal": [
		989,
		9,
		82
	],
	"./components/UserMainSettings/UserEmail/components/EmailModal/": [
		989,
		9,
		82
	],
	"./components/UserMainSettings/UserEmail/components/EmailModal/EmailModal.dictionary": [
		1050,
		3,
		230
	],
	"./components/UserMainSettings/UserEmail/components/EmailModal/EmailModal.dictionary.json": [
		1050,
		3,
		230
	],
	"./components/UserMainSettings/UserEmail/components/EmailModal/index": [
		989,
		9,
		82
	],
	"./components/UserMainSettings/UserEmail/components/EmailModal/index.tsx": [
		989,
		9,
		82
	],
	"./components/UserMainSettings/UserEmail/components/Forms/CodeForm": [
		938,
		9,
		231
	],
	"./components/UserMainSettings/UserEmail/components/Forms/CodeForm.tsx": [
		938,
		9,
		231
	],
	"./components/UserMainSettings/UserEmail/components/Forms/EmailForm": [
		881,
		9,
		83
	],
	"./components/UserMainSettings/UserEmail/components/Forms/EmailForm/": [
		881,
		9,
		83
	],
	"./components/UserMainSettings/UserEmail/components/Forms/EmailForm/EmailForm.dictionary": [
		905,
		3,
		232
	],
	"./components/UserMainSettings/UserEmail/components/Forms/EmailForm/EmailForm.dictionary.json": [
		905,
		3,
		232
	],
	"./components/UserMainSettings/UserEmail/components/Forms/EmailForm/index": [
		881,
		9,
		83
	],
	"./components/UserMainSettings/UserEmail/components/Forms/EmailForm/index.tsx": [
		881,
		9,
		83
	],
	"./components/UserMainSettings/UserEmail/components/ModalBody": [
		904,
		9,
		84
	],
	"./components/UserMainSettings/UserEmail/components/ModalBody/": [
		904,
		9,
		84
	],
	"./components/UserMainSettings/UserEmail/components/ModalBody/ModalBody.dictionary": [
		939,
		3,
		233
	],
	"./components/UserMainSettings/UserEmail/components/ModalBody/ModalBody.dictionary.json": [
		939,
		3,
		233
	],
	"./components/UserMainSettings/UserEmail/components/ModalBody/index": [
		904,
		9,
		84
	],
	"./components/UserMainSettings/UserEmail/components/ModalBody/index.tsx": [
		904,
		9,
		84
	],
	"./components/UserMainSettings/UserEmail/components/ModalContent": [
		1049,
		9,
		234
	],
	"./components/UserMainSettings/UserEmail/components/ModalContent.tsx": [
		1049,
		9,
		234
	],
	"./components/UserMainSettings/UserEmail/components/ModalFooter": [
		990,
		9,
		235
	],
	"./components/UserMainSettings/UserEmail/components/ModalFooter.dictionary": [
		940,
		3,
		236
	],
	"./components/UserMainSettings/UserEmail/components/ModalFooter.dictionary.json": [
		940,
		3,
		236
	],
	"./components/UserMainSettings/UserEmail/components/ModalFooter.tsx": [
		990,
		9,
		235
	],
	"./components/UserMainSettings/UserEmail/components/ModalHeader": [
		906,
		9,
		85
	],
	"./components/UserMainSettings/UserEmail/components/ModalHeader/": [
		906,
		9,
		85
	],
	"./components/UserMainSettings/UserEmail/components/ModalHeader/ModalHeader.dictionary": [
		941,
		3,
		237
	],
	"./components/UserMainSettings/UserEmail/components/ModalHeader/ModalHeader.dictionary.json": [
		941,
		3,
		237
	],
	"./components/UserMainSettings/UserEmail/components/ModalHeader/index": [
		906,
		9,
		85
	],
	"./components/UserMainSettings/UserEmail/components/ModalHeader/index.tsx": [
		906,
		9,
		85
	],
	"./components/UserMainSettings/UserEmail/constants": [
		845,
		9,
		238
	],
	"./components/UserMainSettings/UserEmail/constants.ts": [
		845,
		9,
		238
	],
	"./components/UserMainSettings/UserEmail/email-form-validation": [
		1048,
		9,
		239
	],
	"./components/UserMainSettings/UserEmail/email-form-validation.ts": [
		1048,
		9,
		239
	],
	"./components/UserMainSettings/UserEmail/index": [
		954,
		9,
		6,
		81
	],
	"./components/UserMainSettings/UserEmail/index.tsx": [
		954,
		9,
		6,
		81
	],
	"./components/UserMainSettings/UserMainSettings.module.scss": [
		991,
		9,
		329
	],
	"./components/UserMainSettings/UserPersonalData": [
		907,
		9,
		86
	],
	"./components/UserMainSettings/UserPersonalData/": [
		907,
		9,
		86
	],
	"./components/UserMainSettings/UserPersonalData/UserPersonalData.dictionary": [
		942,
		3,
		240
	],
	"./components/UserMainSettings/UserPersonalData/UserPersonalData.dictionary.json": [
		942,
		3,
		240
	],
	"./components/UserMainSettings/UserPersonalData/index": [
		907,
		9,
		86
	],
	"./components/UserMainSettings/UserPersonalData/index.tsx": [
		907,
		9,
		86
	],
	"./components/UserMainSettings/index": [
		988,
		9,
		6,
		79
	],
	"./components/UserMainSettings/index.tsx": [
		988,
		9,
		6,
		79
	],
	"./components/UserMainSettings/tests/__snapshots__/user-personal-data.spec.jsx.snap": [
		1201,
		9,
		330
	],
	"./components/UserMainSettings/tests/get-component-by-datatest-util": [
		1114,
		9,
		241
	],
	"./components/UserMainSettings/tests/get-component-by-datatest-util.js": [
		1114,
		9,
		241
	],
	"./components/UserMainSettings/tests/user-personal-data.spec": [
		1157,
		9,
		265,
		242
	],
	"./components/UserMainSettings/tests/user-personal-data.spec.jsx": [
		1157,
		9,
		265,
		242
	],
	"./components/UserSecuritySettings": [
		1023,
		9,
		14,
		87
	],
	"./components/UserSecuritySettings/": [
		1023,
		9,
		14,
		87
	],
	"./components/UserSecuritySettings/ModalBody": [
		944,
		9,
		88
	],
	"./components/UserSecuritySettings/ModalBody/": [
		944,
		9,
		88
	],
	"./components/UserSecuritySettings/ModalBody/ModalBody.dictionary": [
		993,
		3,
		243
	],
	"./components/UserSecuritySettings/ModalBody/ModalBody.dictionary.json": [
		993,
		3,
		243
	],
	"./components/UserSecuritySettings/ModalBody/index": [
		944,
		9,
		88
	],
	"./components/UserSecuritySettings/ModalBody/index.tsx": [
		944,
		9,
		88
	],
	"./components/UserSecuritySettings/ModalFooter": [
		1053,
		9,
		244
	],
	"./components/UserSecuritySettings/ModalFooter.tsx": [
		1053,
		9,
		244
	],
	"./components/UserSecuritySettings/ModalResponseError": [
		908,
		9,
		89
	],
	"./components/UserSecuritySettings/ModalResponseError/": [
		908,
		9,
		89
	],
	"./components/UserSecuritySettings/ModalResponseError/ModalResponseError.dictionary": [
		945,
		3,
		245
	],
	"./components/UserSecuritySettings/ModalResponseError/ModalResponseError.dictionary.json": [
		945,
		3,
		245
	],
	"./components/UserSecuritySettings/ModalResponseError/index": [
		908,
		9,
		89
	],
	"./components/UserSecuritySettings/ModalResponseError/index.tsx": [
		908,
		9,
		89
	],
	"./components/UserSecuritySettings/PasswordModal": [
		1085,
		9,
		246
	],
	"./components/UserSecuritySettings/PasswordModal.tsx": [
		1085,
		9,
		246
	],
	"./components/UserSecuritySettings/UserSecuritySettings.dictionary": [
		852,
		3,
		247
	],
	"./components/UserSecuritySettings/UserSecuritySettings.dictionary.json": [
		852,
		3,
		247
	],
	"./components/UserSecuritySettings/UserSecuritySettings.module.scss": [
		853,
		9,
		331
	],
	"./components/UserSecuritySettings/changePassword": [
		943,
		9,
		248
	],
	"./components/UserSecuritySettings/changePassword.ts": [
		943,
		9,
		248
	],
	"./components/UserSecuritySettings/constants": [
		1052,
		9,
		249
	],
	"./components/UserSecuritySettings/constants.ts": [
		1052,
		9,
		249
	],
	"./components/UserSecuritySettings/index": [
		1023,
		9,
		14,
		87
	],
	"./components/UserSecuritySettings/index.tsx": [
		1023,
		9,
		14,
		87
	],
	"./components/UserSecuritySettings/password-form-validation": [
		1054,
		9,
		250
	],
	"./components/UserSecuritySettings/password-form-validation.ts": [
		1054,
		9,
		250
	],
	"./components/UserStakeSettings": [
		994,
		9,
		90
	],
	"./components/UserStakeSettings/": [
		994,
		9,
		90
	],
	"./components/UserStakeSettings/UserStakeSettings.dictionary": [
		1055,
		3,
		251
	],
	"./components/UserStakeSettings/UserStakeSettings.dictionary.json": [
		1055,
		3,
		251
	],
	"./components/UserStakeSettings/index": [
		994,
		9,
		90
	],
	"./components/UserStakeSettings/index.tsx": [
		994,
		9,
		90
	],
	"./components/constants": [
		880,
		9,
		252
	],
	"./components/constants.ts": [
		880,
		9,
		252
	],
	"./components/types": [
		1056,
		7,
		91
	],
	"./components/types/": [
		1056,
		7,
		91
	],
	"./components/types/index": [
		1056,
		7,
		91
	],
	"./components/types/index.ts": [
		1056,
		7,
		91
	],
	"./components/types/userEmail": [
		1158,
		7,
		253
	],
	"./components/types/userEmail.ts": [
		1158,
		7,
		253
	],
	"./components/types/userPhone": [
		1159,
		7,
		254
	],
	"./components/types/userPhone.ts": [
		1159,
		7,
		254
	],
	"./components/utils/error-alert-utils": [
		378,
		9
	],
	"./components/utils/error-alert-utils.ts": [
		378,
		9
	],
	"./components/utils/hide-symbols-utils": [
		1084,
		9,
		255
	],
	"./components/utils/hide-symbols-utils.ts": [
		1084,
		9,
		255
	],
	"./index": [
		312,
		9
	],
	"./index.tsx": [
		312,
		9
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1280;
module.exports = webpackAsyncContext;